export default __webpack_public_path__ + "static/media/upload2.88d532c6.svg";